module.exports = __webpack_public_path__ + "static/media/empty.3ee29ba3.svg";